import { Grid, Typography } from "@mui/material"
import { useTypeComponent } from "./styles"

const TypeComponent = (props: any) => {
  const styles = useTypeComponent()
  let usersAssigned = props?.current

  return (
    <Grid
      container
      justifyContent="left"
      alignItems="center"
      columnSpacing={1}
    >
      <Grid
        item
        sx={{ color: '#828282' }}
        xl={10}
        lg={10}
        md={10}
        sm={10}
        xs={10}
      >
        <Typography sx={styles.textItem}>
          {usersAssigned ? ( 
            <span>{usersAssigned == 'preventive' ? 'Preventivo' : usersAssigned == 'corrective' ? 'Correctivo': 'N/A'}</span>
          ) : (
            'N/A'
          )}
        </Typography>
      </Grid>
    </Grid>
  )
}

export { TypeComponent }